import {
  WelcomeSearchContainer,
  ButtonBack,
  SearchHeader,
  SearchInputContainer,
  ImageContainer,
  ChurchListContainer,
  ChurchListItem,
  ChurchItemLogo,
  ChurchItemNoLogo,
  ChurchItemName,
  ChurchSearchFooter,
  FooterContent,
  FooterDescription,
} from './index.styled';
import LeftCorner from '../../../assets/images/leftCorner.svg';
import ChurchSearchIcon from '../../../assets/images/church-search-icon.svg';

export const ChurchSearchLayout = ({
  handleSearch,
  searchValue,
  handleSearchValue,
  churchList,
  selectChurch,
  handleModalOpen,
}) => {
  return (
    <WelcomeSearchContainer isSearch>
      <SearchHeader>
        <ButtonBack onClick={() => handleSearch(false)}>
          <LeftCorner />
        </ButtonBack>
        Find Your Church
      </SearchHeader>
      <SearchInputContainer>
        <input
          value={searchValue}
          onChange={handleSearchValue}
          placeholder="Search by Church Name or Zip Code"
        />
      </SearchInputContainer>
      {searchValue && churchList ? (
        <ChurchListContainer>
          {churchList.map((item, index) => (
            <ChurchListItem
              key={'church' + index}
              isNotLast={index !== churchList.length - 1}
              onClick={() => selectChurch(item)}
            >
              {item.logo ? (
                <ChurchItemLogo logo={item.logo} />
              ) : (
                <ChurchItemNoLogo>logo</ChurchItemNoLogo>
              )}
              <ChurchItemName>
                <span>{item.name}</span>
                <span>{`${item.city !== '' && item.city + ','} ${
                  item.state
                }`}</span>
              </ChurchItemName>
            </ChurchListItem>
          ))}
        </ChurchListContainer>
      ) : (
        <ImageContainer>
          <ChurchSearchIcon />
        </ImageContainer>
      )}
      {searchValue && (
        <ChurchSearchFooter>
          <FooterContent>
            <span>Don’t see your church?</span>
            <span onClick={() => handleModalOpen('helper')}>Let Us Know</span>
          </FooterContent>
          <FooterDescription>
            <span>v1.1.1 (260)</span>
            <span>© 2022 Togather</span>
          </FooterDescription>
        </ChurchSearchFooter>
      )}
    </WelcomeSearchContainer>
  );
};
